import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { darkTheme } from '../../lib/tokens';
import { findPipeline } from './data';
import { formatDate } from './formatDate';
import { PipelineBody } from './components/PipelineBody';

/**
 * Praesentationsmodus (CUR-1571).
 *
 * Der Grund ist nicht Aesthetik: die Seitenleiste zeigt die E-Mail des
 * angemeldeten Kontos, und die Navigation fuehrt sichtbar zu Nutzerdaten und
 * Feedback. Beides gehoert nicht ins Bild, waehrend eine fremde Firma
 * zuschaut. Deshalb steht diese Route ausserhalb der AppShell — mit eigenem
 * ProtectedRoute in App.tsx, der Zugang bleibt also unveraendert geschuetzt.
 */
export function PresentationPage(): JSX.Element {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const doc = findPipeline(slug);

  useEffect(() => {
    function onKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') navigate(`/pipelines/${slug ?? ''}`);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate, slug]);

  if (!doc) return <Navigate to="/pipelines" replace />;

  return (
    <div className="min-h-screen bg-bg-base">
      <div className="mx-auto max-w-6xl px-6 py-10 lg:px-10 lg:py-14">
        <header className="flex flex-wrap items-baseline justify-between gap-3">
          <div>
            <p className="text-sm font-bold uppercase tracking-widest" style={{ color: darkTheme.colors.accentLight }}>
              Currivium · Fertigungsstrecke
            </p>
            <h1 className="mt-1 text-4xl font-bold text-text-primary">{doc.title}</h1>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-text-tertiary">Stand {formatDate(doc.asOf)}</span>
            <button
              type="button"
              onClick={() => navigate(`/pipelines/${doc.slug}`)}
              className="rounded-md border px-3 py-1.5 text-xs text-text-secondary hover:text-text-primary"
              style={{ borderColor: darkTheme.colors.borderSubtle }}
            >
              Beenden <kbd className="ml-1 text-[10px] text-text-tertiary">Esc</kbd>
            </button>
          </div>
        </header>

        <div className="mt-8">
          <PipelineBody doc={doc} large />
        </div>
      </div>
    </div>
  );
}
